import React from 'react';
import { Alert } from '@zapier/design-system';

import Link from 'app/common/components/Link';
import { PLATFORM_MARKETING_BASE_URL } from 'app/developer-v3/constants';

const RoleWarning = (
  <Alert status="warning">
    If you do not have an official relationship with the owner of this API,
    Zapier cannot publish the app in its public directory. You may still create
    an integration for your own organization’s use. See our{' '}
    <Link href={`${PLATFORM_MARKETING_BASE_URL}/tos`}>
      Developer Platform Agreement
    </Link>{' '}
    for more detail.
  </Alert>
);

export default RoleWarning;
